// 统一配置文件
import store from '../store/index.js'
export default {
	// 白名单  不要验证token的 
	whiteListApi: [
		'/', '/index','/corpore','/corpore/detail','/livestream','/cooperation','/enterprise','/biddemand','/release', '/about','/weiTuo','/huiShou','/huiShouRegister', '/404',
	],
	// 接口随机时间
	rand: Math.random(),
	// 图片地址前部分
	url: 'https://paimai-1304461808.file.myqcloud.com/',
	
	
	
	
	
	// 上传图片地址
	uploadUrl: 'https://api.haopaiwang.net/api/upload',
	headers: {
		Authorization: "Bearer " + store.state.user.token,
	},
	
	
	
	
	
	status: [{
			code: 0,
			name: '全部',
			isActive: true
		}, {
			code: 1,
			name: '即将开始',
			isActive: false
		}, {
			code: 2,
			name: '正在进行',
			isActive: false
		},
		{
			code: 3,
			name: '已结束',
			isActive: false
		},
	],
	time: [{
			code: 0,
			name: '全部',
			isActive: true
		}, {
			code: 1,
			name: '未来3天',
			isActive: false
		}, {
			code: 2,
			name: '未来7天',
			isActive: false
		},
		{
			code: 3,
			name: '未来15天',
			isActive: false
		}
	]
}